/**
 * @file components/shared/PremiumBadge.jsx
 * @description Small badge showing free tier usage or premium status.
 */

import { Crown, Zap } from "lucide-react";
import { PLANS } from "../../services/subscription";

export function PremiumBadge({ isPremium, remaining, onUpgrade }) {
  if (isPremium) {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-brand-green/10 border border-brand-green/20">
        <Crown size={12} className="text-brand-green" />
        <span className="text-[10px] font-bold text-brand-green uppercase tracking-wider">
          Premium
        </span>
      </div>
    );
  }

  return (
    <button
      onClick={onUpgrade}
      style={{ touchAction: "manipulation" }}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 hover:border-brand-green/30 transition-colors group"
    >
      <Zap size={12} className="text-brand-amber group-hover:text-brand-green transition-colors" />
      <span className="text-[10px] font-bold text-gray-400 group-hover:text-gray-300 uppercase tracking-wider">
        {remaining}/{PLANS.free.aiCallsPerDay} today
      </span>
    </button>
  );
}
